export default "__VITE_ASSET__8gIImzqL__"